"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataEncryptionAlgorithm;
(function (DataEncryptionAlgorithm) {
    DataEncryptionAlgorithm["Aes128_cbc"] = "http://www.w3.org/2001/04/xmlenc#aes128-cbc";
    DataEncryptionAlgorithm["Aes256_cbc"] = "http://www.w3.org/2001/04/xmlenc#aes256-cbc";
    DataEncryptionAlgorithm["Tripledes_cbc"] = "http://www.w3.org/2001/04/xmlenc#tripledes-cbc";
    DataEncryptionAlgorithm["Aes128_gcm"] = "http://www.w3.org/2009/xmlenc11#aes128-gcm";
})(DataEncryptionAlgorithm = exports.DataEncryptionAlgorithm || (exports.DataEncryptionAlgorithm = {}));
//# sourceMappingURL=data-encryption-algorithm.js.map